import React, { useState } from 'react';
import {
  Col,
  Container,
  Row,
  Form,
  FloatingLabel,
  Alert,
} from 'react-bootstrap';
import emailjs from 'emailjs-com';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import mosheurRahman from '../../../images/mosheur-rahman.jpg';

const ContactMe = () => {
  const [show, setShow] = useState(false);
  const [review, setReview] = useState({});
  const handleInputOnBlur = (e) => {
    const field = e.target.name;
    const value = e.target.value;
    const data = { ...review };
    data[field] = value;
    setReview(data);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setShow(false);
    emailjs
      .sendForm(
        'service_emj0i6s',
        'template_jii5frh',
        e.target,
        'sFGpSBoHDn0h1N7Fq'
      )
      .then(
        (result) => {
          if (result.text === 'OK') {
            setShow(true);
          }
        },
        (error) => {
          setShow(false);
        }
      );
    e.target.reset();
  };
  return (
    <div>
      <Container className="my-5">
        <Row>
          <Col md={12}>
            <h1 className="contact-title my-3">Let's Work Together</h1>
            <h5 className="sub-title mb-5">
              Have a project you'd like to discuss? I am interested in working
              with any kinds of project that match with my skill.
            </h5>
          </Col>
          <Col
            md={6}
            className="px-5 pt-4 mb-5"
            style={{ color: '#000fff', fontWeight: '400', fontSize: '1.2rem' }}>
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" className="mb-3">
                  <FloatingLabel label="Full Name">
                    <Form.Control
                      size="lg"
                      style={{
                        backgroundColor: 'transparent',
                        color: '#CCD6F6',
                      }}
                      required
                      type="text"
                      placeholder="Full Name"
                      name="name"
                      onBlur={handleInputOnBlur}
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="12" className="mb-3">
                  <FloatingLabel label="Email">
                    <Form.Control
                      size="lg"
                      style={{
                        backgroundColor: 'transparent',
                        color: '#CCD6F6',
                      }}
                      required
                      type="email"
                      placeholder="Email"
                      name="email"
                      onBlur={handleInputOnBlur}
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col} md="12" className="mb-3">
                  <FloatingLabel label="Subject">
                    <Form.Control
                      size="lg"
                      style={{
                        backgroundColor: 'transparent',
                        color: '#CCD6F6',
                      }}
                      required
                      type="text"
                      placeholder="Subject"
                      name="subject"
                      onBlur={handleInputOnBlur}
                    />
                  </FloatingLabel>
                </Form.Group>

                <Form.Group
                  className="mb-3"
                  as={Col}
                  md="12"
                  controlId="exampleForm.ControlTextarea1">
                  <FloatingLabel label="Message">
                    <Form.Control
                      as="textarea"
                      required
                      style={{
                        height: '100px',
                        backgroundColor: 'transparent',
                        color: '#CCD6F6',
                      }}
                      size="lg"
                      type="text"
                      placeholder="Message"
                      name="message"
                      onBlur={handleInputOnBlur}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Row>
              <p className="text-start my-3">
                {' '}
                <button className="w-100 btn-All" type="submit">
                  Say Hi
                </button>
              </p>
            </Form>
            <Alert
              show={show}
              style={{ backgroundColor: '#112240', color: '#8892b0' }}>
              <Alert.Heading>
                your message has been sent successfully.
              </Alert.Heading>
            </Alert>
          </Col>
          <Col md={6}>
            <Row className="g-0">
              <Col md={12} className="mx-auto">
                <div className="d-flex align-items-center justify-content-center mb-3 contact-img">
                  <img
                    style={{ height: '250px' }}
                    className="img-fluid rounded"
                    src={mosheurRahman}
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <div className="text-center mt-3">
                    <h3>
                      <strong>Mosheur Rahman</strong>
                    </h3>
                    <p className="mb-0 pb-0">
                      <strong className="mb-0 pb-0">
                        mosheurrahman104@gmail.com <br />
                        +44 7403327077 <br />
                        London, UK.
                      </strong>
                    </p>

                    <div className="pt-0 mt-0">
                      <a
                        href="https://www.facebook.com/mosheur.pau"
                        target="_blank"
                        rel="noopener noreferrer">
                        <FontAwesomeIcon
                          icon={faFacebook}
                          className="footer-icon"
                        />
                      </a>

                      <a
                        href="https://www.linkedin.com/in/mosheurrahman29/"
                        target="_blank"
                        rel="noopener noreferrer">
                        <FontAwesomeIcon
                          icon={faLinkedinIn}
                          className="footer-icon"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactMe;
